<template>
    <div class="logo-on">
        <van-cell-group class="logo-cell-type">
            <van-field v-model="manageMent" required clearable label="账号" placeholder="请输入账号"/>
            <van-field
                    maxlength="18"
                    v-model="idNum"
                    required
                    clearable
                    label="身份证号码"
                    placeholder="请输入身份证号码"
            />
            <van-field v-model="mobilePhone" required clearable label="手机号" placeholder="请输入手机号"/>
            <van-field v-model="name" required clearable label="姓名" placeholder="请输入真实姓名"/>

            <van-field label="证件有效起始时间:" placeholder="请选择身份证有效期开始时间" readonly  required is-link @click="openTime"
                       :value="certEffDate" />
            <van-datetime-picker v-model="currentDate" :min-date="minDate" type="date" v-if="timeStartShow" @confirm="handleTime"
                                 @cancel="closeTime" />

            <van-field required clickable label="选择证件有效期" v-model="idValidityPeriod" readonly placeholder="请选择"
                       @click="showPickerReason  = true"  is-link/>
            <van-popup v-model="showPickerReason" position="bottom">
                <van-picker show-toolbar :columns="reasonListitem" value-key="name" @cancel="showPickerReason = false"
                            @confirm="onConfirm"/>
            </van-popup>
            <!--图形验证码-->
            <pic-code ref="verificationCode"  @setVerificationStatus="getVerificationStatus"></pic-code>
            <!--短信验证码-->
            <note-code :source="'blackListSms'" :receivePhone="mobilePhone" :VerificationStatus="verificationInfo" ref="getVerificationNoteCode" @setVerification="getSMS"></note-code>
<!--            <note-code :receivePhone="vericode" :member="userInfo" :VerificationStatus="verificationInfo" ref="getVerificationNoteCode" @setVerification="getSMS"></note-code>-->

        </van-cell-group>
        <div class="tips">
            <div class="tips-img tips-img-danger">
                <span class="text-danger">提示：</span>
                <span class="text-danger">应省政府要求注册时间超过五年的用户需进行二次核验</span>
            </div>
        </div>
        <button class="nextbtn" @click="toStepTwo">完成</button>

    </div>
</template>

<script>
    import { CellGroup, Field, Checkbox,DatetimePicker, Popup, Picker, Cell,Toast,Dialog} from 'vant'
    import PicCode from '@/components/verification-code-input/PicCode' // 短信验证码组件
    import NoteCode from '@/components/verification-code-input/NoteCode' // 短信验证码组件
    import { idCardRegex, phoneRegex} from '@/utils/regex'
    import {memberApi} from '@/api/member'
    export default {
        name: "AccountBlack",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Checkbox.name]: Checkbox,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Cell.name]: Cell,
            [Toast.name]: Toast,
            [Dialog.Component.name]:Dialog.Component,
            NoteCode,PicCode
        },
        data(){
            return{
                currentDate: new Date(),
                reasonListitem: ["5年", "10年", "20年", "长期有效"],
                showPickerReason: false, // 是否显示选择框
                minDate: new Date(1940,0,1),
                timeStartShow: false,//时间开始显示
                idNum:'',//身份证号码
                manageMent:'',//账号
                mobilePhone:'',//手机号码
                name:'',//真实姓名
                idValidity:"",
                vericode:'',
                verificationInfo:{},//图形验证码信息
                certEffDate:"",  //身份证有效期起始日期
                idValidityPeriod:"", //有效期,(5/10/20长期有效传字符串”0”,或者空值)
                phoneCode:''
            }
        },
        mounted(){
            Toast.setDefaultOptions({ duration: 1500 });
        },
        methods:{

            handleTime(value1) {
                let year = this.currentDate.getFullYear();
                var tf = function (i) { return (i < 10 ? '0' : '') + i};
                let month = tf(this.currentDate.getMonth() + 1);
                let day = tf(this.currentDate.getDate());
                value1 = year  + month  + day
                this.certEffDate = value1
                this.timeStartShow = false
            },
            closeTime() {
                this.timeStartShow = false
            },
            openTime() {
                this.timeStartShow = true
            },
            onConfirm(value) {
                this.idValidityPeriod = value
                if(this.idValidityPeriod === '长期有效' ){
                    this.idValidity = ''
                }else if(this.idValidityPeriod === '5年'){
                    this.idValidity = '5'
                }else if (this.idValidityPeriod === '10年'){
                    this.idValidity = '10'
                }else if (this.idValidityPeriod === '20年'){
                    this.idValidity = '20'
                }
                this.showPickerReason = false
            },

           async toStepTwo(){
               this.$refs.verificationCode.passValue();
               this.$refs.getVerificationNoteCode.passValue();
               // debugger
               if(this.manageMent===""){
                   Toast.fail("请输入账号")
                   return
               }else if(this.idNum===""){
                   Toast.fail("请输入身份证号")
                   return
                }else if(!idCardRegex(this.idNum)){
                   Toast.fail("请输入正确的身份证号")
                   return
                }else if(this.mobilePhone.trim()===""){
                    Toast.fail("请输入手机号")
                    return
                }else if(!phoneRegex(this.mobilePhone.trim())){
                    Toast.fail("请输入正确的手机号")
                    return
                }else if(this.certEffDate === ''){
                   Toast.fail('请选择身份证有效期开始时间');
               }else if(this.idValidityPeriod === ''){
                   Toast.fail('请选择证件有效期');
               }else if(this.name===""){
                   Toast.fail("请输入真实姓名")
                   return
               }else if(this.verificationInfo.verificationCode===undefined){
                    Toast.fail("请输入图形验证码")
                    return
                }else if(!this.verificationInfo.IsInputSuccStatus){
                    Toast.fail("请输入正确的图形验证码")
                    return
                }else if(this.phoneCode===""){
                    Toast.fail("请输入短信验证码")
                    return
                }else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '校验中...'
                    })
                    let data = {
                        userName:this.manageMent,
                        idCard:this.idNum,
                        mobilePhone:this.mobilePhone,
                        name:this.name,
                        certEffDate:this.certEffDate,
                        idValidityPeriod:this.idValidity,
                        vericode:this.phoneCode
                    }
                    try{
                        const res = await this.$httpUtils.postCommonUtils(memberApi.memberAuthBlack,data)
                        Toast.clear()
                        console.log(res)
                        if (res.data.succ) {
                            idCard: this.idNum
                            Dialog.alert({
                                message: '二次核验成功'
                            }).then(() => {
                                this.$router.replace('/sign-up/login')
                            });
                        } else {
                            if (res.data && res.data.status === 1) {
                                Toast.fail("二次核验成功");
                            } else if (res.data && res.data.status === 2) {
                                Toast.fail("二次核验失败");
                            }else if (res.data && res.data.status === 3) {
                                Toast.fail("二次核验失败，信息不匹配");
                            }else if (res.data && res.data.status === 4) {
                                Toast.fail("请联系人工处理问题");
                            }else if (res.data && res.data.status === 5) {
                                Toast.fail("用户信息不在核验列表，无需核验");
                            }else if (res.data && res.data.status === 6) {
                                Toast.fail("短信验证码错误");
                            }else if (res.data && res.data.status === 7) {
                                Toast.fail("实名认证不通过");
                            } else {
                                Toast.fail("服务功能不稳定，请稍后再试或前往鄂汇办APP进行账号登陆后进行二次核验！！！");
                            }
                        }
                    }catch (e) {
                        Toast.clear()
                        Toast.fail("服务功能不稳定，请稍后再试或前往鄂汇办APP进行账号登陆后进行二次核验！！！")
                        console.log(e)
                    }

                }

            },
            //获取图形验证码
            getVerificationStatus(value){
                this.verificationInfo = value
            },
            //获取短信
            getSMS(value){
                this.phoneCode=value;
                console.log(value)
            },
            //子组件调用
            getNewPic(){
                this.$refs.verificationCode.interactionVerificationCode()
                this.$refs.verificationCode.passValue()
            }

        }
    }
</script>

<style scoped>
    @import "~@assets/css/public/signup.css";
    .logo-on{overflow: auto}
    .step-four{text-align: center;margin-top: 138px}
    .step-four img{display: inline-block;height: 228px}
    .step-four p{padding: 40px 0}
    .greentext{color: #18A74B;font-weight: bold;font-size: 30px}
    .bluetext{position: relative;color: #2664AD;font-size:24px;padding-right: 3px}
    .bluetext:before{position: absolute;content: '';left: 0;right: 0;bottom: 0;height: 1px;background: #2664AD}
    .firstp{font-size: 30px}
    .secondp{font-size: 24px}
    .orangetext{font-weight: bold;color: #E58B1E;font-size: 36px;}
    .step-five{padding-top: 138px;text-align: center}
    .step-five img{height: 228px;display: inline-block}
    .step-five p{font-size: 36px;padding-top: 40px}
    .tips {
        margin: 70px 0 10px 0
    }
    .text-danger{
        color:#2664AD;
    }
</style>
